import { useQuery } from '@tanstack/react-query';
import { getDashboardMetrics } from '../services/dashboard';
import { dashboardQueryKeys } from './query-keys';
import { formatDateForApi } from '../utils/dateUtils';

export const useDashboardMetricsQuery = (startDate, endDate) => {
  const formattedStartDate = startDate ? formatDateForApi(startDate) : '';
  const formattedEndDate = endDate ? formatDateForApi(endDate) : '';
  const isDateRangeReady = Boolean(formattedStartDate && formattedEndDate);

  return useQuery({
    queryKey: dashboardQueryKeys.metrics(formattedStartDate, formattedEndDate),
    enabled: isDateRangeReady,
    queryFn: async () => {
      const result = await getDashboardMetrics({
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      });

      if (!result.success) {
        throw new Error(result.message || 'Failed to load dashboard metrics');
      }

      return result.data;
    },
  });
};
